// src/utils/cep.js

/**
 * Busca dados de endereço a partir de um CEP usando a API ViaCEP.
 * @param {string} cep - O CEP a ser buscado (apenas números).
 * @returns {Promise<object|null>} Objeto com { logradouro, bairro, localidade, uf } ou null em caso de erro.
 */
export const lookupCep = async (cep) => {
  if (!cep || cep.length !== 8 || !/^\d+$/.test(cep)) {
    console.error('CEP inválido para busca:', cep);
    return null;
  }

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();

    if (data.erro) {
      console.warn('CEP não encontrado:', cep);
      return null;
    }

    return {
      street: data.logradouro,
      neighborhood: data.bairro,
      city: data.localidade,
      state: data.uf,
    };
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    return null;
  }
};
